import React from 'react';

import { Link } from '@edx/components/link';
import { useAuth } from '@edx/hooks/use-auth';
import { Body } from '@edx/components/typography';
import NOISE_PATTERN from '@edx/img/noise_pattern.png';

import { FooterProps } from './';

export const Footer: React.FC<FooterProps> = ({ projectName, logo, columns, simpleVersion }) => {
  const { isLoggedOut } = useAuth();

  return simpleVersion ? (
    <div className="max-w-6xl mx-auto px-4 md:px-10">
      <div className="bg-gray-600 font-body py-6" style={{ background: `#292929 url(${NOISE_PATTERN}) repeat` }}>
        <Body className="text-gray-500 text-center" size="small" variant="semibold">
          © 2021 {projectName}. Todos los derechos reservados.
        </Body>
      </div>
    </div>
  ) : (
    <div className="bg-gray-600 font-body py-6" style={{ background: `#292929 url(${NOISE_PATTERN}) repeat` }}>
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="border-b border-white border-opacity-10 pt-6 pb-12">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="flex justify-center md:justify-start">
              <div className="w-10 h-10 md:w-12 md:h-12">
                <img src={logo} alt="" />
              </div>
            </div>

            {columns.map(({ sections }, columnIndex) => (
              <div key={columnIndex} className="flex flex-col space-y-4">
                {sections.map(
                  ({ sectionName, items, inlineItems, hideLoggedIn }) =>
                    (isLoggedOut || !hideLoggedIn) && (
                      <div key={sectionName} className="flex flex-col items-center md:items-start">
                        <h5 className="text-gray-600 text-center md:text-left">{sectionName}</h5>

                        <ul
                          className={
                            inlineItems
                              ? 'mt-1 flex space-x-4'
                              : 'flex flex-wrap justify-center md:flex-col md:space-x-0 mt-1 space-x-3'
                          }
                        >
                          {items.map(({ item, resourcePath }) => (
                            <li key={resourcePath}>
                              <Link href={resourcePath} className="text-white">
                                {item}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col-reverse justify-between md:flex-row md:space-y-0 mt-8 text-gray-600 text-xs tracking-widest uppercase font-medium">
          <div className="md:mt-0 md:text-left mt-4 text-center">
            &copy; 2020 {projectName}. Todos Los Derechos Reservados.
          </div>

          <ul className="flex justify-center md:justify-start space-x-2">
            <li>
              <Link href="/aviso-legal" rel="nofollow" className="hover:text-white transition duration-150">
                Aviso Legal
              </Link>
            </li>
            <li>
              <Link href="/privacidad" rel="nofollow" className="hover:text-white transition duration-150">
                Privacidad
              </Link>
            </li>
            <li>
              <Link href="/cookies" rel="nofollow" className="hover:text-white transition duration-150">
                Cookies
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
